import { useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { logger } from '@/features/help/utils/logger';
import ahiLogoWhite from '../../../../assets/images/ahiLogoWhite.png';

/**
 * Component to display when the broker's free trial has ended
 */
export const TrialEnded = () => {
  useEffect(() => {
    logger.info('Application Form', 'Displaying trial ended message');
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-slate-900 bg-opacity-95">
      <div className="text-center mx-auto max-w-md px-4">
        <div className="flex justify-center mb-6">
          <img src={ahiLogoWhite} alt="AHI Logo" className="h-24 w-auto" />
        </div>
        <h2 className="text-white text-2xl font-bold mb-3">Free Trial Ended</h2>
        <p className="text-slate-300 mb-6">
          The person who sent you this form has reached their free trial limit.
        </p>
        <p className="text-slate-400 text-sm mb-3">
          Please contact them directly to complete your application.
        </p>
        <div className="bg-slate-800 p-4 rounded-lg mb-6">
          <p className="text-slate-300 text-sm">
            This application form is temporarily unavailable because the account owner needs to
            upgrade their plan. Your information is safe, and they'll be able to access your
            application once they upgrade.
          </p>
        </div>
        <div className="mt-8">
          <a
            href={import.meta.env.VITE_APP_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-indigo-300 hover:text-indigo-200 text-sm"
          >
            Visit Application Portal
            <ArrowUpRight className="ml-1 h-3 w-3" />
          </a>
        </div>
      </div>
    </div>
  );
};
